import React, { useEffect, useState } from 'react';

export const useMobileCheck = (breakpoint = 835) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < breakpoint);
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [breakpoint]);

  return isMobile;
};

export const CustomPrevArrow = (props: {
  className?: string;
  style?: React.CSSProperties;
  onClick?: React.MouseEventHandler;
}) => {
  const isMobile = useMobileCheck();
  const { className, style, onClick } = props;

  if (isMobile) return null;

  return (
    <div
      className={className}
      style={{ ...style, width: '47px', height: '109px' }}
      onClick={onClick}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="47"
        height="109"
        viewBox="0 0 47 109"
        fill="none"
      >
        <foreignObject x="-18.0884" y="-19" width="82.5215" height="144.77">
          <div
            style={{
              backdropFilter: 'blur(15px)',
              clipPath: 'url(#bgblur_0_196_19382_clip_path)',
              height: '100%',
              width: '100%',
            }}
          />
        </foreignObject>
        <g filter="url(#filter0_d_196_19382)" data-figma-bg-blur-radius="30">
          <path
            d="M34.4185 12.3008L15.2222 52.1689L34.4331 94.5312L31.7007 95.7695L11.9116 52.1318L31.7153 11L34.4185 12.3008Z"
            fill="#A1DCDC"
            fillOpacity="0.8"
            shapeRendering="crispEdges"
          />
        </g>
        <defs>
          <filter
            id="filter0_d_196_19382"
            x="-18.0884"
            y="-19"
            width="82.5215"
            height="144.77"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="1" />
            <feGaussianBlur stdDeviation="5.85" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.631373 0 0 0 0 0.862745 0 0 0 0 0.862745 0 0 0 1 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_196_19382"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_196_19382"
              result="shape"
            />
          </filter>
          <clipPath
            id="bgblur_0_196_19382_clip_path"
            transform="translate(18.0884 19)"
          >
            <path d="M34.4185 12.3008L15.2222 52.1689L34.4331 94.5312L31.7007 95.7695L11.9116 52.1318L31.7153 11L34.4185 12.3008Z" />
          </clipPath>
        </defs>{' '}
      </svg>
    </div>
  );
};

export const CustomNextArrow = (props: {
  className?: string;
  style?: React.CSSProperties;
  onClick?: React.MouseEventHandler;
}) => {
  const isMobile = useMobileCheck();
  const { className, style, onClick } = props;

  if (isMobile) return null;

  return (
    <div
      className={className}
      style={{ ...style, width: '47px', height: '109px' }}
      onClick={onClick}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="47"
        height="109"
        viewBox="0 0 47 109"
        fill="none"
      >
        <foreignObject x="-17.4331" y="-19" width="82.5215" height="144.77">
          <div
            style={{
              backdropFilter: 'blur(15px)',
              clipPath: 'url(#bgblur_0_196_19383_clip_path)',
              height: '100%',
              width: '100%',
            }}
          />
        </foreignObject>
        <g filter="url(#filter0_d_196_19383)" data-figma-bg-blur-radius="30">
          <path
            d="M12.5815 94.4687L31.7778 54.6006L12.5669 12.2383L15.2993 11L35.0884 54.6377L15.2847 95.7695L12.5815 94.4687Z"
            fill="#A1DCDC"
            fillOpacity="0.8"
            shapeRendering="crispEdges"
          />
        </g>
        <defs>
          <filter
            id="filter0_d_196_19383"
            x="-17.4331"
            y="-19"
            width="82.5215"
            height="144.77"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="1" />
            <feGaussianBlur stdDeviation="5.85" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.631373 0 0 0 0 0.862745 0 0 0 0 0.862745 0 0 0 1 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_196_19383"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_196_19383"
              result="shape"
            />
          </filter>
          <clipPath
            id="bgblur_0_196_19383_clip_path"
            transform="translate(17.4331 19)"
          >
            <path d="M12.5815 94.4687L31.7778 54.6006L12.5669 12.2383L15.2993 11L35.0884 54.6377L15.2847 95.7695L12.5815 94.4687Z" />
          </clipPath>
        </defs>{' '}
      </svg>
    </div>
  );
};
